<div [id]="props.element" style="width: 100%; height: 400px"></div>
